var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dimbox showImage"},[_c('div',{staticClass:"mHeader"},[_c('button',{on:{"click":_vm.close}},[_c('span',{staticClass:"material-icons"},[_vm._v(" close ")])])]),_c('div',{staticClass:"mBody"},[_c('img',{attrs:{"src":_vm.image}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }